import { API_URL } from "../utils/config";
import { getAuthToken } from "./getAuthToken";

export const fetchTasksFromAPI = () => async (dispatch) => {
  
  const token = getAuthToken();
  if (!token) {
    console.warn("User not authenticated, skipping API call.");
    return;
  }

  // let boundingBoxCoordinates = '';
  // if(getState().mapping) {
  //   const { north, south, east, west } = getState().mapping;
  //   boundingBoxCoordinates = north ? `?north=${north}&east=${east}&south=${south}&west=${west}` : '';
  // }
  
  let batchId = 1;
  const numberOfRecords = 5000;
  let data = [];
  const go = true;
  while(go){
    try {
      const response = await fetch(API_URL + `/tasks?t=${Date.now()}&batchId=${batchId}&numberOfRecords=${numberOfRecords}`, {
        headers: {
          Authorization: token, // Send mock token
          "Cache-Control": "no-cache, no-store, must-revalidate",
        }
      });

      const d = await response.json();
      data.push(...d);

      if(d.length === 0) {
        break;
      }
      
      if(d.length < numberOfRecords) {
        dispatch({ type: 'tasks/setTasks', payload: data });
        break;
      }
      batchId++;
      

    } catch (error) {
      console.error("Error fetching tasks:", error);
      break;
    }
  }
};

export const fetchPatrolsFromAPI = () => async (dispatch) => {
  const token = getAuthToken();
  if (!token) {
    console.warn("User not authenticated, skipping API call.");
    return;
  }


  // let boundingBoxCoordinates = '';
  // if(getState().mapping) {
  //   const { north, south, east, west } = getState().mapping;
  //   boundingBoxCoordinates = north ? `?north=${north}&east=${east}&south=${south}&west=${west}` : '';
  // }
  try {
    const response = await fetch(API_URL + `/patrols?t=${Date.now()}`, {
      headers: {
        Authorization: token, // Send mock token
        "Cache-Control": "no-cache, no-store, must-revalidate",
      }
    });
    const data = await response.json();
    dispatch({ type: 'patrols/setPatrols', payload: data });
  } catch (error) {
    console.error("Error fetching patrols:", error);
  }
};

export const assignPatrol = async (caseId, patrolId) => {
  await fetch(API_URL + '/api/assignPatrol', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ caseId, patrolId }),
  });
};
